import { useEffect, useMemo, useState } from "react";
import blogs from "../data/blogs.json";

const PUBLICATION_TIME_ZONE = "Asia/Kolkata";

function getDateKey(date = new Date()) {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: PUBLICATION_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(date);
    const values = Object.fromEntries(
        parts.filter(({ type }) => type !== "literal").map(({ type, value }) => [type, value])
    );

    return `${values.year}-${values.month}-${values.day}`;
}

export function isBlogPublished(blog, currentDate = getDateKey()) {
    return Boolean(blog?.date) && blog.date <= currentDate;
}

export default function usePublishedBlogs() {
    const [currentDate, setCurrentDate] = useState(() => getDateKey());

    useEffect(() => {
        const refreshDate = () => setCurrentDate(getDateKey());
        const intervalId = window.setInterval(refreshDate, 60 * 1000);

        return () => window.clearInterval(intervalId);
    }, []);

    return useMemo(
        () =>
            blogs
                .filter((blog) => isBlogPublished(blog, currentDate))
                .sort(
                    (first, second) =>
                        new Date(second.date).getTime() -
                        new Date(first.date).getTime()
                ),
        [currentDate]
    );
}
